
export class Notice {
    constructor(
        public id: number = null,
        public editedBy: number = null,
        public title: string = '',
        public deletedAt: string = '',
        public deletedBy: number = null,
        public editedAt: string = '',
        public categoryId: number = null,
        public createdByUser: any = null,
        public createdAt: string = '',
        public pdf: boolean = false,
        public status: string = '',
        public content: string = '',
        public schedule: any = null,
        public playlist: any = null,
        public duration: any = null,
        public noticeName: any = ''
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/Notice.ts